import {
  type AiWorkflowFinalizationEntry,
  type BaseAiElementDefinition,
  type ElementContext,
  SELECTOR_INPUT_TOKEN,
  type WorkflowContext,
} from '../../../ai';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type, @typescript-eslint/no-empty-interface
export interface SchedulerDefinition extends BaseAiElementDefinition<'scheduler'> {}

export interface SchedulerContext extends ElementContext<'scheduler'> {
  element: SchedulerDefinition;
}

export interface SchedulerResolvedContext extends SchedulerContext {
  workflowContext?: WorkflowContext;
  actionWorkflowContext?: WorkflowContext;
  workflowsToFinalize?: AiWorkflowFinalizationEntry[];
}

export const SCHEDULER_INPUT_TOKEN = '$scheduler';
export { SELECTOR_INPUT_TOKEN };

export const SCHEDULER_RESOLVED_INPUT = 'scheduler_1';
